export default __webpack_public_path__ + "static/r400-large-b1bbc34b6188639894158d126bdb5043.png";